import { Link, useSearchParams } from 'react-router-dom';

import { Gate } from '../../../global/contexts/auth/auth';
import ProjectsOverview from './overview';
import RepositoriesOverview from '../../repositories/layouts/overview';

import '../styles/portfolio.css';

// Proyectos y repositorios, en una sección con dos pestañas.
//
// Un repositorio no existe sin proyecto: `repositories.project_id` es NOT NULL,
// y el listado filtra por él. Eran dos entradas del riel para dos mitades de la
// misma pregunta —qué se está construyendo, y en qué repos vive—, y mirando una
// se necesitaba la otra.
//
// LA PESTAÑA VA EN LA QUERY Y NO EN EL PATH, que es lo contrario de lo que
// hacen Desarrollo y «Usuarios y equipos». La razón es concreta: acá
// `/admin/projects/:id` ya está tomado por el espacio de trabajo de un
// proyecto, así que `/admin/projects/repositorios` sería un segmento estático
// compitiendo con uno dinámico del mismo largo. Funciona —lo estático gana— y
// se lee como una trampa esperando a que alguien la toque.

const TABS = [
    { key: 'proyectos',    title: 'Proyectos',    domain: 'projects:read' },
    { key: 'repositorios', title: 'Repositorios', domain: 'repositories:read' },
];

export default function PortfolioScreen() {
    const [params, setParams] = useSearchParams();
    const tab = params.get('tab') === 'repositorios' ? 'repositorios' : 'proyectos';

    const setTab = (key) => {
        const target = new URLSearchParams(params);
        if (key === 'repositorios') target.set('tab', 'repositorios');
        else target.delete('tab');
        // Los filtros propios de cada lista no cruzan: `kind` y `group` son de
        // repositorios, `client` y `state` son de proyectos. El PROYECTO sí
        // cruza — es la misma columna en las dos tablas.
        for (const key of ['page', 'kind', 'group', 'client', 'state', 'q']) target.delete(key);
        setParams(target);
    };

    return (
        <section className="portfolio">
            <header className="portfolio__header">
                <div className="portfolio__heading">
                    <span className="portfolio__eyebrow">Qué se está construyendo</span>
                    <h2 className="portfolio__title">Proyectos</h2>
                </div>

                <div className="portfolio__actions">
                    <Gate domain="projects:write">
                        <Link to="/admin/projects/new" className="portfolio__action">
                            + Nuevo proyecto
                        </Link>
                    </Gate>
                </div>
            </header>

            <nav className="portfolio__tabs" aria-label="Secciones">
                {TABS.map(item => (
                    <Gate key={item.key} domain={item.domain}>
                        <button
                            type="button"
                            className={`portfolio__tab ${item.key === tab ? 'portfolio__tab--active' : ''}`}
                            onClick={() => setTab(item.key)}
                            aria-current={item.key === tab ? 'page' : undefined}
                        >
                            {item.title}
                        </button>
                    </Gate>
                ))}
            </nav>

            <div className="portfolio__panel">
                {tab === 'proyectos' && <ProjectsOverview embedded />}
                {tab === 'repositorios' && <RepositoriesOverview embedded />}
            </div>
        </section>
    );
}
